module.exports = __webpack_public_path__ + "static/img/giz.79ad14a7.jpg";